import { FC, useEffect } from 'react';
import './App.css';
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'nprogress/nprogress.css';
import { SnackbarProvider } from 'notistack';
import { ThemeProvider } from '@mui/material/styles';
// import './i18n';
import RTL from './components/RTL';
import useScrollReset from './hooks/useScrollReset';
import useSettings from './hooks/useSettings';
import { createTheme } from './theme';

import './utils/yupAugment'
import { useDispatch } from 'react-redux';
import dataProvider from './dataProvider/rest';
import AppRoutes from './App.routes';


const App: FC = () => {
  const { settings } = useSettings();
  useScrollReset();

  const dispatch = useDispatch()
  useEffect(() => {
    const setDispatcher = dataProvider.setDispatcher
    if (setDispatcher) {
      setDispatcher(dispatch)
    }
  }, [dispatch])

  const theme = createTheme({
    direction: settings.direction,
    responsiveFontSizes: settings.responsiveFontSizes,
    roundedCorners: settings.roundedCorners,
    theme: settings.theme
  });

  return (
    <ThemeProvider theme={theme}>
      <RTL direction={settings.direction || 'ltr'}>
        <SnackbarProvider
          dense
          maxSnack={3}
        >
          <AppRoutes />

        </SnackbarProvider>
      </RTL>
    </ThemeProvider>
  );
};

export default App;
